import * as accountantTypes from '../accountants/actions'

const initialState = {
  modalType: null,
  modalProps: {}
}
// NOTE convention on how to add additional modal types:
// https://stackoverflow.com/questions/35623656/how-can-i-display-a-modal-dialog-in-redux-that-performs-asynchronous-actions/35641680
export default function modal(state = initialState, action) {
  switch (action.type) {
    case accountantTypes.SEND_DATA_EXPORT_SUCCESS:
      return {
        ...state,
        modalType: 'ALERT_MODAL',
        modalProps: {
          modalTitle: "Report sent!",
          modalBody: "Your report was generated and sent to your Everlance account email.",
          alertStyle: "success",
          okButtonTitle: "Got it.",
          cancelButtonTitle: "Cancel",
          showModal: true
        }
      }
    case 'HIDE_MODAL':
      return {
        ...state,
        modalType: 'ALERT_MODAL',
        modalProps: {
          ...state.modalProps,
          showModal: false
        }
      }

    case 'SHOW_MODAL':
      return {
        modalType: action.modalType,
        modalProps: action.modalProps
      }

    case 'HIDE_MODAL_2':
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modal/reducer.js